import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/NominateRequest/DeliveryDetails.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
class DeliveryDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            errorMessage: false,
            data: [{}, {}, {}, {}, {}, {}, {}, {}, {}]
        }
    }
    componentDidMount = () => {
    }
    handleDeliveryDetails = () => {
    }
    addDeliveryDetails = () => {
    }
    render() {
        return (
            <div class="DeliveryDetailsOutercolor">
                <MetaDecorator title={TitleDescription.preferencesTitle} description={TitleDescription.preferencesDescription} />
                <Header tilesFetched={() => { }} />
                <div class="DeliveryDetailsOuterDivcss">
                    <div id="DeliveryDetailsBoxDiv">
                        <nav class="DeliveryDetailsNavbar">
                            <div className="DeliveryDetailsNavbarName">
                                <small id="DeliveryDetailsNavbarText">Delivery Details</small>
                            </div>
                            <div id="CDForMobileView" className="ContainerDetailesNavbarNameRight">
                                <small class="ContainerDetailesNavbarRightText" onClick={() => this.addDeliveryDetails()}>Add Delivery Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <nav class="ContainerDetailesMobileNavbar">
                            <div className="ContainerDetailesNavbarNameRight">
                                <small class="ContainerDetailesNavbarRightText" onClick={() => this.addDeliveryDetails()}>Add Delivery Details</small>
                            </div>
                        </nav>
                        <div class="DeliverDetailsMidPartition">
                            <div id="DeliverDetailsDataTopDiv">
                                {!this.state.errorMessage ?
                                    (this.state.data?.map((truckdataTemporary, index) => {
                                        return (
                                            <div class="DeliveryDetailsMainCardDiv" onClick={() => this.handleDeliveryDetails(index)}>
                                                <div class="DeliveryDetailsDivRow" >
                                                    <div class="DeliveryMainColumn1">
                                                        <div class='DeliveryMainColumn'>
                                                            <small id="DeliveryDetailsLable">Destination</small>
                                                            <small id='DeliveryDetailsValue'>City Center</small>
                                                        </div>
                                                        <div class='DeliveryMainColumn'>
                                                            <small id="DeliveryDetailsLable">Destination Code</small>
                                                            <small id='DeliveryDetailsValue'>ZA CTT</small>
                                                        </div>
                                                        <div class='DeliveryMainColumn'>
                                                            <small id="DeliveryDetailsLable">Haulage Company</small>
                                                            <small id='DeliveryDetailsValue'>ABC Transport Limited</small>
                                                        </div>
                                                    </div>
                                                    <div class="DeliveryDetailsArrow" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>);
                                    }))
                                    :
                                    <div class="notruckfound1">
                                        <small id="DeliveryDetailsErrMessage">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="DeliverDetailsFooterUnfixed">
                    <Footer />
                </div>
                <div class="DeliverDetailsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default DeliveryDetails;